import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const svgClass = 'w-full h-12 text-[#4A90E2] fill-none stroke-current stroke-[1.5]';
const CarIcons = {
  SUV: () => <svg viewBox="0 0 110 48" className={svgClass} data-id="element-44">
      {/* Wheels - large with spokes for off-road look */}
      <circle cx="24" cy="37" r="7" data-id="element-45" />
      <circle cx="24" cy="37" r="4" data-id="element-46" />
      <line x1="24" y1="30" x2="24" y2="33" strokeWidth="0.6" data-id="element-47" />
      <line x1="24" y1="41" x2="24" y2="44" strokeWidth="0.6" data-id="element-48" />
      <line x1="17" y1="37" x2="20" y2="37" strokeWidth="0.6" data-id="element-49" />
      <line x1="28" y1="37" x2="31" y2="37" strokeWidth="0.6" data-id="element-50" />
      <circle cx="84" cy="37" r="7" data-id="element-51" />
      <circle cx="84" cy="37" r="4" data-id="element-52" />
      <line x1="84" y1="30" x2="84" y2="33" strokeWidth="0.6" data-id="element-53" />
      <line x1="84" y1="41" x2="84" y2="44" strokeWidth="0.6" data-id="element-54" />
      <line x1="77" y1="37" x2="80" y2="37" strokeWidth="0.6" data-id="element-55" />
      <line x1="88" y1="37" x2="91" y2="37" strokeWidth="0.6" data-id="element-56" />
      {/* Body - Toyota SW4 GR profile: muscular, tall, angular */}
      <path d="M6 37 H17 M31 37 H77 M91 37 H100 C102 37 103 35 103 33 L103 22 C103 20 102 19 100 19 L92 19 L92 10 C92 8 90 6 88 6 L66 6 L44 6 C40 6 36 8 33 12 L26 19 L12 19 C9 19 7 20 6 22 L4 28 C3 30 4 33 5 35 L6 37 Z" data-id="element-57" />
      {/* Muscular wheel arches */}
      <path d="M14 37 C14 31 19 27 24 27 C29 27 34 31 34 37" strokeWidth="1.2" data-id="element-58" />
      <path d="M74 37 C74 31 79 27 84 27 C89 27 94 31 94 37" strokeWidth="1.2" data-id="element-59" />
      {/* Windows - two sections with thick D-pillar */}
      <path d="M35 13 L42 7 L65 7 L65 18 L30 18 Z" strokeLinejoin="round" data-id="element-60" />
      <path d="M65 7 L88 7 L88 18 L65 18" strokeLinejoin="round" data-id="element-61" />
      <line x1="52" y1="7" x2="52" y2="18" data-id="element-62" />
      {/* Roof rails */}
      <line x1="40" y1="4" x2="86" y2="4" strokeWidth="1" data-id="element-63" />
      <line x1="42" y1="6" x2="42" y2="4" strokeWidth="0.8" data-id="element-64" />
      <line x1="60" y1="6" x2="60" y2="4" strokeWidth="0.8" data-id="element-65" />
      <line x1="78" y1="6" x2="78" y2="4" strokeWidth="0.8" data-id="element-66" />
      {/* Side mirror */}
      <path d="M28 16 L25 13 L25 16" data-id="element-67" />
      {/* GR aggressive front bumper */}
      <path d="M6 28 L10 24 L12 24" strokeWidth="1" data-id="element-68" />
      <line x1="5" y1="32" x2="10" y2="32" strokeWidth="0.8" data-id="element-69" />
      {/* Front fog light / intake */}
      <rect x="7" y="24" width="4" height="2" rx="0.5" strokeWidth="0.6" data-id="element-70" />
      {/* Side step */}
      <line x1="34" y1="35" x2="74" y2="35" strokeWidth="0.8" data-id="element-71" />
      {/* Door lines */}
      <line x1="52" y1="18" x2="52" y2="33" strokeWidth="0.6" data-id="element-72" />
      {/* Door handles */}
      <line x1="42" y1="23" x2="47" y2="23" data-id="element-73" />
      <line x1="58" y1="23" x2="63" y2="23" data-id="element-74" />
      {/* Rear bumper */}
      <line x1="98" y1="32" x2="102" y2="32" strokeWidth="0.8" data-id="element-75" />
      {/* Rear light */}
      <rect x="99" y="22" width="2" height="5" rx="0.5" strokeWidth="0.6" data-id="element-76" />
      {/* Front headlight */}
      <path d="M8 20 L12 19 L12 22" strokeWidth="0.8" data-id="element-77" />
      {/* Body line / character line */}
      <line x1="14" y1="26" x2="96" y2="26" strokeWidth="0.5" data-id="element-78" />
    </svg>,
  Truck: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-79">
      {/* Wheels */}
      <circle cx="24" cy="33" r="6" data-id="element-80" />
      <circle cx="24" cy="33" r="3" data-id="element-81" />
      <circle cx="78" cy="33" r="6" data-id="element-82" />
      <circle cx="78" cy="33" r="3" data-id="element-83" />
      {/* Cab */}
      <path d="M10 33 H18 M30 33 H52 L52 19 L46 10 C44 8 42 7 39 7 L22 7 C19 7 17 9 16 11 L12 19 L8 19 C6 19 5 21 5 23 L5 29 C5 31 6 33 8 33" data-id="element-84" />
      {/* Cab windows */}
      <path d="M17 12 L22 8 L39 8 L44 12 L44 18 L15 18 Z" strokeLinejoin="round" data-id="element-85" />
      <line x1="32" y1="8" x2="32" y2="18" data-id="element-86" />
      {/* Bed */}
      <path d="M52 33 H72 M84 33 H94 C96 33 97 31 97 29 L97 19 L52 19" data-id="element-87" />
      <line x1="97" y1="19" x2="97" y2="33" data-id="element-88" />
      {/* Mirror */}
      <path d="M14 16 L11 14 L11 17" data-id="element-89" />
      {/* Door handle */}
      <line x1="28" y1="23" x2="33" y2="23" data-id="element-90" />
      {/* Bed detail */}
      <line x1="60" y1="19" x2="60" y2="33" strokeWidth="0.5" strokeDasharray="2 2" data-id="element-91" />
    </svg>,
  Sedan: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-92">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-93" />
      <circle cx="22" cy="33" r="3" data-id="element-94" />
      <circle cx="78" cy="33" r="6" data-id="element-95" />
      <circle cx="78" cy="33" r="3" data-id="element-96" />
      {/* Body */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L93 23 C92 21 90 20 88 20 L80 20 L72 12 C69 9 65 8 61 8 L38 8 C34 8 30 10 28 13 L22 20 L12 20 C10 20 8 22 7 24 L6 29 C6 31 7 33 8 33 Z" data-id="element-97" />
      {/* Windows */}
      <path d="M29 14 L36 9 L61 9 L70 14 L70 19 L25 19 Z" strokeLinejoin="round" data-id="element-98" />
      <line x1="46" y1="9" x2="46" y2="19" data-id="element-99" />
      <line x1="60" y1="9.5" x2="60" y2="19" data-id="element-100" />
      {/* Mirror */}
      <path d="M24 18 L21 16 L21 18" data-id="element-101" />
      {/* Door lines */}
      <line x1="46" y1="19" x2="46" y2="30" data-id="element-102" />
      {/* Door handles */}
      <line x1="36" y1="24" x2="41" y2="24" data-id="element-103" />
      <line x1="52" y1="24" x2="57" y2="24" data-id="element-104" />
      {/* Trim line */}
      <line x1="12" y1="27" x2="88" y2="27" strokeWidth="0.5" data-id="element-105" />
    </svg>,
  Coupe: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-106">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-107" />
      <circle cx="22" cy="33" r="3" data-id="element-108" />
      <circle cx="78" cy="33" r="6" data-id="element-109" />
      <circle cx="78" cy="33" r="3" data-id="element-110" />
      {/* Body */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L93 23 C92 21 90 20 88 20 L78 20 L68 10 C65 8 60 7 56 7 L38 9 C34 9 30 11 28 14 L22 20 L12 20 C10 20 8 22 7 24 L6 29 C6 31 7 33 8 33 Z" data-id="element-111" />
      {/* Window - single large */}
      <path d="M30 15 L37 10 L56 8 L66 12 L66 19 L26 19 Z" strokeLinejoin="round" data-id="element-112" />
      {/* Mirror */}
      <path d="M25 17 L22 15 L22 17" data-id="element-113" />
      {/* Door handle */}
      <line x1="42" y1="24" x2="47" y2="24" data-id="element-114" />
      {/* Trim line */}
      <line x1="12" y1="27" x2="88" y2="27" strokeWidth="0.5" data-id="element-115" />
      {/* Rear vent */}
      <line x1="82" y1="22" x2="85" y2="26" strokeWidth="0.8" data-id="element-116" />
    </svg>,
  Convertible: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-117">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-118" />
      <circle cx="22" cy="33" r="3" data-id="element-119" />
      <circle cx="78" cy="33" r="6" data-id="element-120" />
      <circle cx="78" cy="33" r="3" data-id="element-121" />
      {/* Body - low, no roof */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L93 23 C92 21 90 20 88 20 L20 20 C15 20 10 22 8 25 L6 29 C6 31 7 33 8 33 Z" data-id="element-122" />
      {/* Windshield frame */}
      <path d="M30 20 L35 12 L40 12" strokeLinejoin="round" data-id="element-123" />
      {/* Folded top hint */}
      <path d="M60 18 C62 16 65 16 67 18" strokeWidth="0.8" strokeDasharray="2 1" data-id="element-124" />
      {/* Mirror */}
      <path d="M28 18 L25 16 L25 18" data-id="element-125" />
      {/* Door line */}
      <line x1="48" y1="18" x2="48" y2="30" data-id="element-126" />
      {/* Door handle */}
      <line x1="38" y1="24" x2="43" y2="24" data-id="element-127" />
      {/* Trim line */}
      <line x1="12" y1="27" x2="88" y2="27" strokeWidth="0.5" data-id="element-128" />
      {/* Headrest hints */}
      <rect x="42" y="16" width="3" height="4" rx="1" strokeWidth="0.8" data-id="element-129" />
      <rect x="50" y="16" width="3" height="4" rx="1" strokeWidth="0.8" data-id="element-130" />
    </svg>,
  Luxury: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-131">
      {/* Wheels */}
      <circle cx="20" cy="33" r="6" data-id="element-132" />
      <circle cx="20" cy="33" r="3" data-id="element-133" />
      <line x1="17" y1="33" x2="23" y2="33" strokeWidth="0.5" data-id="element-134" />
      <line x1="20" y1="30" x2="20" y2="36" strokeWidth="0.5" data-id="element-135" />
      <circle cx="80" cy="33" r="6" data-id="element-136" />
      <circle cx="80" cy="33" r="3" data-id="element-137" />
      <line x1="77" y1="33" x2="83" y2="33" strokeWidth="0.5" data-id="element-138" />
      <line x1="80" y1="30" x2="80" y2="36" strokeWidth="0.5" data-id="element-139" />
      {/* Body - long elegant */}
      <path d="M6 33 H14 M26 33 H74 M86 33 H94 C96 33 97 31 97 29 L95 23 C94 21 92 20 90 20 L82 20 L74 12 C71 9 67 8 63 8 L36 8 C32 8 28 10 26 13 L20 20 L10 20 C8 20 6 22 5 24 L4 29 C4 31 5 33 6 33 Z" data-id="element-140" />
      {/* Windows - 3 sections */}
      <path d="M27 14 L34 9 L63 9 L72 14 L72 19 L23 19 Z" strokeLinejoin="round" data-id="element-141" />
      <line x1="42" y1="9" x2="42" y2="19" data-id="element-142" />
      <line x1="56" y1="9.5" x2="56" y2="19" data-id="element-143" />
      <line x1="64" y1="9" x2="64" y2="19" data-id="element-144" />
      {/* Chrome trim line */}
      <line x1="8" y1="26" x2="92" y2="26" strokeWidth="0.8" data-id="element-145" />
      {/* Mirror */}
      <path d="M22 18 L19 16 L19 18" data-id="element-146" />
      {/* Door handles */}
      <line x1="34" y1="23" x2="38" y2="23" data-id="element-147" />
      <line x1="50" y1="23" x2="54" y2="23" data-id="element-148" />
    </svg>,
  SportsCar: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-149">
      {/* Wheels */}
      <circle cx="22" cy="34" r="6" data-id="element-150" />
      <circle cx="22" cy="34" r="3" data-id="element-151" />
      <circle cx="78" cy="34" r="6" data-id="element-152" />
      <circle cx="78" cy="34" r="3" data-id="element-153" />
      {/* Body - very low aggressive */}
      <path d="M8 34 H16 M28 34 H72 M84 34 H94 C96 34 97 32 97 30 L95 25 C94 23 92 22 90 22 L80 22 L72 15 C69 12 64 10 60 10 L40 12 C36 12 32 14 30 17 L24 22 L12 22 C10 22 8 24 7 26 L6 30 C6 32 7 34 8 34 Z" data-id="element-154" />
      {/* Window - fastback style */}
      <path d="M32 18 L39 13 L58 11 L70 16 L70 21 L28 21 Z" strokeLinejoin="round" data-id="element-155" />
      {/* Mirror */}
      <path d="M27 20 L24 18 L24 20" data-id="element-156" />
      {/* Air intake */}
      <path d="M10 28 L14 26" strokeWidth="0.8" data-id="element-157" />
      <path d="M86 28 L90 26" strokeWidth="0.8" data-id="element-158" />
      {/* Door handle */}
      <line x1="44" y1="25" x2="48" y2="25" data-id="element-159" />
      {/* Spoiler hint */}
      <path d="M88 22 L92 20 L92 22" strokeWidth="0.8" data-id="element-160" />
    </svg>,
  Minivan: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-161">
      {/* Wheels */}
      <circle cx="22" cy="34" r="6" data-id="element-162" />
      <circle cx="22" cy="34" r="3" data-id="element-163" />
      <circle cx="78" cy="34" r="6" data-id="element-164" />
      <circle cx="78" cy="34" r="3" data-id="element-165" />
      {/* Body - tall boxy */}
      <path d="M8 34 H16 M28 34 H72 M84 34 H92 C94 34 95 32 95 30 L95 12 C95 9 93 7 90 7 L30 7 C26 7 22 9 20 12 L14 20 L8 20 C6 20 5 22 5 24 L5 30 C5 32 6 34 8 34 Z" data-id="element-166" />
      {/* Windows - large greenhouse */}
      <path d="M22 13 L28 8 L90 8 L90 18 L18 18 Z" strokeLinejoin="round" data-id="element-167" />
      <line x1="40" y1="8" x2="40" y2="18" data-id="element-168" />
      <line x1="58" y1="8" x2="58" y2="18" data-id="element-169" />
      <line x1="75" y1="8" x2="75" y2="18" data-id="element-170" />
      {/* Roof rails */}
      <line x1="28" y1="5" x2="88" y2="5" strokeWidth="0.8" data-id="element-171" />
      {/* Sliding door line */}
      <line x1="58" y1="18" x2="58" y2="31" data-id="element-172" />
      {/* Door handles */}
      <line x1="36" y1="24" x2="40" y2="24" data-id="element-173" />
      <line x1="64" y1="24" x2="68" y2="24" data-id="element-174" />
      {/* Mirror */}
      <path d="M17 17 L14 15 L14 17" data-id="element-175" />
    </svg>,
  Wagon: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-176">
      {/* Wheels */}
      <circle cx="22" cy="33" r="6" data-id="element-177" />
      <circle cx="22" cy="33" r="3" data-id="element-178" />
      <circle cx="78" cy="33" r="6" data-id="element-179" />
      <circle cx="78" cy="33" r="3" data-id="element-180" />
      {/* Body - sedan with extended flat roof */}
      <path d="M8 33 H16 M28 33 H72 M84 33 H92 C94 33 95 31 95 29 L95 12 C95 10 93 9 91 9 L62 9 C58 9 54 10 52 12 L28 13 C25 13 22 14 20 16 L14 20 L10 20 C8 20 6 22 6 24 L5 29 C5 31 6 33 8 33 Z" data-id="element-181" />
      {/* Windows */}
      <path d="M29 14 L36 10 L62 10 L90 10 L90 19 L24 19 Z" strokeLinejoin="round" data-id="element-182" />
      <line x1="46" y1="10" x2="46" y2="19" data-id="element-183" />
      <line x1="62" y1="10" x2="62" y2="19" data-id="element-184" />
      <line x1="78" y1="10" x2="78" y2="19" data-id="element-185" />
      {/* Roof rails */}
      <line x1="34" y1="7" x2="88" y2="7" strokeWidth="0.8" data-id="element-186" />
      {/* Mirror */}
      <path d="M23 17 L20 15 L20 17" data-id="element-187" />
      {/* Door handles */}
      <line x1="36" y1="24" x2="40" y2="24" data-id="element-188" />
      <line x1="52" y1="24" x2="56" y2="24" data-id="element-189" />
      {/* Trim line */}
      <line x1="10" y1="27" x2="90" y2="27" strokeWidth="0.5" data-id="element-190" />
    </svg>,
  Hatchback: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-191">
      {/* Wheels */}
      <circle cx="24" cy="33" r="6" data-id="element-192" />
      <circle cx="24" cy="33" r="3" data-id="element-193" />
      <circle cx="76" cy="33" r="6" data-id="element-194" />
      <circle cx="76" cy="33" r="3" data-id="element-195" />
      {/* Body - compact, sloped rear */}
      <path d="M10 33 H18 M30 33 H70 M82 33 H90 C92 33 93 31 93 29 L90 20 C89 19 88 18 86 18 L78 18 L70 10 C68 8 65 7 62 7 L38 8 C34 8 30 10 28 13 L22 18 L14 18 C12 18 10 20 9 22 L8 29 C8 31 9 33 10 33 Z" data-id="element-196" />
      {/* Windows */}
      <path d="M30 14 L36 9 L62 8 L68 12 L68 17 L26 17 Z" strokeLinejoin="round" data-id="element-197" />
      <line x1="48" y1="8.5" x2="48" y2="17" data-id="element-198" />
      {/* Rear hatch angle */}
      <path d="M78 18 L86 18" data-id="element-199" />
      {/* Mirror */}
      <path d="M25 16 L22 14 L22 16" data-id="element-200" />
      {/* Door line */}
      <line x1="48" y1="17" x2="48" y2="30" data-id="element-201" />
      {/* Door handles */}
      <line x1="36" y1="23" x2="40" y2="23" data-id="element-202" />
      <line x1="54" y1="23" x2="58" y2="23" data-id="element-203" />
      {/* Trim line */}
      <line x1="12" y1="26" x2="86" y2="26" strokeWidth="0.5" data-id="element-204" />
    </svg>,
  CargoVan: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-205">
      {/* Wheels */}
      <circle cx="20" cy="35" r="5" data-id="element-206" />
      <circle cx="20" cy="35" r="2.5" data-id="element-207" />
      <circle cx="80" cy="35" r="5" data-id="element-208" />
      <circle cx="80" cy="35" r="2.5" data-id="element-209" />
      {/* Body - tall commercial van */}
      <path d="M8 35 H15 M25 35 H75 M85 35 H94 C96 35 97 33 97 31 L97 8 C97 6 95 5 93 5 L35 5 C32 5 29 6 27 8 L18 18 L8 18 C6 18 4 20 4 22 L4 31 C4 33 5 35 8 35 Z" data-id="element-210" />
      {/* Cab window */}
      <path d="M20 10 L26 6 L35 6 L35 16 L16 16 Z" strokeLinejoin="round" data-id="element-211" />
      {/* Cargo area - large panel */}
      <path d="M35 5 L35 35" data-id="element-212" />
      {/* Cargo door */}
      <line x1="65" y1="8" x2="65" y2="32" strokeWidth="0.8" data-id="element-213" />
      {/* Door handle on cargo */}
      <line x1="63" y1="20" x2="67" y2="20" data-id="element-214" />
      {/* Van nose detail */}
      <path d="M8 18 L4 22" data-id="element-215" />
      {/* Rear door lines */}
      <rect x="88" y="10" width="7" height="22" rx="1" strokeWidth="0.5" data-id="element-216" />
      {/* Mirror */}
      <path d="M15 15 L12 13 L12 16" data-id="element-217" />
      {/* Front bumper */}
      <line x1="5" y1="30" x2="10" y2="30" strokeWidth="0.8" data-id="element-218" />
    </svg>,
  Hybrid: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-219">
      {/* Leaf shape - circular */}
      <path d="M50 8 C38 8 30 16 30 26 C30 34 38 38 50 38 C62 38 68 30 68 22 C68 14 62 8 50 8 Z" strokeLinejoin="round" data-id="element-220" />
      {/* Leaf vein / stem diagonal */}
      <path d="M36 36 L50 22 L64 10" data-id="element-221" />
      {/* Small leaf detail veins */}
      <path d="M44 28 L50 22" strokeWidth="0.8" data-id="element-222" />
      <path d="M50 22 L56 16" strokeWidth="0.8" data-id="element-223" />
    </svg>,
  Electric: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-224">
      {/* Lightning bolt - bold */}
      <path d="M56 4 L38 22 L48 22 L44 40 L62 22 L52 22 Z" strokeLinejoin="round" strokeWidth="2" data-id="element-225" />
    </svg>,
  PHEV: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-226">
      {/* Plug prongs */}
      <line x1="44" y1="4" x2="44" y2="14" strokeWidth="2" strokeLinecap="round" data-id="element-227" />
      <line x1="56" y1="4" x2="56" y2="14" strokeWidth="2" strokeLinecap="round" data-id="element-228" />
      {/* Plug body */}
      <rect x="38" y="14" width="24" height="12" rx="3" data-id="element-229" />
      {/* Cord */}
      <line x1="50" y1="26" x2="50" y2="32" strokeWidth="2" data-id="element-230" />
      <path d="M50 32 C50 36 46 38 42 38" strokeWidth="2" strokeLinecap="round" data-id="element-231" />
    </svg>,
  Diesel: () => <svg viewBox="0 0 100 44" className={svgClass} data-id="element-232">
      {/* Fuel drop shape */}
      <path d="M50 6 C50 6 36 20 36 28 C36 35.7 42.3 42 50 42 C57.7 42 64 35.7 64 28 C64 20 50 6 50 6 Z" strokeLinejoin="round" data-id="element-233" />
      {/* Letter D */}
      <path d="M46 24 L46 34 L50 34 C54 34 56 31 56 29 C56 27 54 24 50 24 Z" strokeLinejoin="round" data-id="element-234" />
    </svg>
};
const carTypes = [{
  name: 'SUVs',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/aiidpgUWsHhnMgc5MjoD7N/Captura_de_pantalla_2026-03-30_a_la(s)_11.39.39_p._m..png" alt="SUV" className="w-full h-[80px] object-contain" data-id="element-235" />
}, {
  name: 'Camionetas',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/erVwCv4HA3dRafd8916c1H/Captura_de_pantalla_2026-03-30_a_la(s)_11.44.51_p._m..png" alt="Camioneta" className="w-full h-[80px] object-contain" data-id="element-236" />
}, {
  name: 'Sedanes',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/t9pfnk2bNgHKyvcKHbs2Wd/Captura_de_pantalla_2026-03-30_a_la(s)_11.48.21_p._m..png" alt="Sedán" className="w-full h-[80px] object-contain" data-id="element-237" />
}, {
  name: 'Coupés',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/bLbyMzitZ8mRW8C9gun8Up/Captura_de_pantalla_2026-03-30_a_la(s)_11.48.21_p._m..png" alt="Coupé" className="w-full h-[80px] object-contain" data-id="element-238" />
}, {
  name: 'Convertibles',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/rd8pNuKrJGkyjZNYnqsWvk/Captura_de_pantalla_2026-03-31_a_la(s)_12.09.49_a._m..png" alt="Convertible" className="w-full h-[80px] object-contain" data-id="element-239" />
}, {
  name: 'Lujo',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/cJFDpZJYDwEyKUf7XhEARt/Captura_de_pantalla_2026-03-31_a_la(s)_12.10.30_a._m..png" alt="Lujo" className="w-full h-[80px] object-contain" data-id="element-240" />
}, {
  name: 'Deportivos',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/gVu7uZT9Lbvo1N9yVR295P/Captura_de_pantalla_2026-03-31_a_la(s)_12.11.28_a._m..png" alt="Deportivo" className="w-full h-[80px] object-contain" data-id="element-241" />
}, {
  name: 'Hatchbacks',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/71L7LPgNNq5zKjzsS6h6DN/Captura_de_pantalla_2026-03-31_a_la(s)_12.13.41_a._m..png" alt="Hatchback" className="w-full h-[80px] object-contain" data-id="element-242" />
}, {
  name: 'Utilitarios',
  Icon: () => <img src="https://cdn.magicpatterns.com/uploads/2pexmrLiphfnznyFWhr3kh/Captura_de_pantalla_2026-03-31_a_la(s)_12.18.21_a._m..png" alt="Utilitario" className="w-full h-[80px] object-contain" data-id="element-243" />
}];
interface CarTypeCarouselProps {
  selectedType?: string | null;
  onSelectType?: (type: string | null) => void;
}
export function CarTypeCarousel({
  selectedType,
  onSelectType
}: CarTypeCarouselProps) {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <div className="bg-[#D5DEE8] rounded-2xl p-6 mb-8 relative overflow-hidden" data-id="element-244">
      {/* Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-245">
        <div className="flex items-center gap-3" data-id="element-246">
          <svg className="w-6 h-6 text-gray-800" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-247">
            <path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2" data-id="element-248" />
            <circle cx="7" cy="17" r="2" data-id="element-249" />
            <path d="M9 17h6" data-id="element-250" />
            <circle cx="17" cy="17" r="2" data-id="element-251" />
          </svg>
          <h2 className="text-lg text-gray-900" data-id="element-252">
            ¿Qué <span className="font-bold" data-id="element-253">tipo</span> de auto querés?
          </h2>
        </div>

        {/* Navigation Arrows */}
        <div className="flex items-center gap-2" data-id="element-254">
          <button onClick={() => scroll('left')} className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-400 hover:text-gray-900 hover:border-gray-300 transition-colors shadow-sm" data-id="element-255">
            <ChevronLeft className="w-5 h-5" data-id="element-256" />
          </button>
          <button onClick={() => scroll('right')} className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-900 hover:border-gray-300 transition-colors shadow-sm" data-id="element-257">
            <ChevronRight className="w-5 h-5" data-id="element-258" />
          </button>
        </div>
      </div>

      {/* Carousel Cards */}
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto pb-2 scrollbar-hide -mx-2 px-2" data-id="element-259">
        {carTypes.map((type, index) => {
        const isActive = selectedType === type.name;
        return <button key={index} onClick={() => onSelectType?.(isActive ? null : type.name)} className={`flex-shrink-0 w-[160px] h-[130px] rounded-xl border shadow-sm transition-all flex flex-col items-center justify-between pt-3 pb-3 group ${isActive ? 'bg-[#4A90E2] border-[#4A90E2] shadow-md ring-2 ring-[#4A90E2]/30' : 'bg-white border-[#D5D5D5] hover:border-[#4A90E2] hover:shadow-md'}`} data-id="element-260">
              <div className="flex-1 flex items-center justify-center w-32 group-hover:scale-105 transition-transform duration-300" data-id="element-261">
                <type.Icon data-id="element-262" />
              </div>
              <span className={`text-[15px] font-medium ${isActive ? 'text-white' : 'text-gray-800'}`} data-id="element-263">
                {type.name}
              </span>
            </button>;
      })}
      </div>
    </div>;
}